import type { AnalyticsProps } from '../../types/assertive'
import debug from '../console'
const logger = debug.withTag('utils:scriptLoadAY')

export async function scriptLoadAY(
  ayEntityId: string | unknown | null,
  analyticsProps: AnalyticsProps,
  layoutName: string,
  layoutSkeleton: string,
  cohort: string | null
) {
  // use this to control whether ads are enabled in development
  const { isDevMode, devDisableAds, devAYTestEntityId } =
    useRuntimeConfig().public

  if (isDevMode && devDisableAds) {
    logger.info('Ads are disabled in development mode')
    return {
      ayManagerEnv: null,
      assertive: null,
      loading: false,
    }
  }

  if (window.assertive && window.ayManagerEnv) {
    return {
      ayManagerEnv: window.ayManagerEnv,
      assertive: window.assertive,
      loading: true,
    }
  }

  const entityId =
    isDevMode && devAYTestEntityId ? devAYTestEntityId : ayEntityId

  const analyticsOptions = {
    integrations: { webAnalytics: true },
    logUnfilled: true,

    // When adding new custom dimensions please update the docs here
    // https://redbrickmedia.atlassian.net/wiki/spaces/Duplex/pages/3727458322/Assertive+Yield+Analytic+Mappings
    custom: {
      layout: layoutName,
      userState: null,
      custom_1: analyticsProps.type_tag,
      custom_2: analyticsProps.ntp_app_version,
      custom_3: analyticsProps.host_browser_app_version,
      custom_4: getTruncatedUrl(),
      custom_5: layoutSkeleton,
      custom_6: cohort,
    },
    useHistoryChangeTrigger: true,
  }
  const assertiveOptions = {
    ayEntityId: entityId,
    debug: true,
    analytics: analyticsOptions,
  }

  window.assertiveYieldAnalytics ??= { ...analyticsOptions }
  window.assertive ??= { ...assertiveOptions }
  window.ayManagerEnv ??= { cmd: [] }

  try {
    if (entityId) {
      await loadScriptAsync('head', {
        src: `https://${entityId}.ay.delivery/manager/${entityId}`,
      })
    }
  } catch (error) {
    logger.error('Failed to load Assertive Yield SDK:', error)
    return {
      ayManagerEnv: null,
      assertive: null,
      loading: false,
    }
  }

  window.assertiveQueue = window.assertiveQueue || []
  window.assertiveQueue.push(function () {
    if (window.assertive?.analytics?.custom) {
      window.assertive.analytics.custom.custom_5 = layoutSkeleton
      window.assertive.analytics.custom.custom_6 = cohort
    }
  })

  return {
    ayManagerEnv: window.ayManagerEnv,
    assertive: window.assertive,
    loading: true,
  }
}
